
import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { changeIncentiveTab, updateIncentiveData } from '../../../stateManagement/actions/incentiveActions'
import { useSelector } from 'react-redux'
import { TabDefinitionType } from './tabConfig'
import './TabDefinition.css'
import { openPopup } from '../../../stateManagement/actions/popupActions'

export const TabDefinition = (props:{tabDefinition: TabDefinitionType, tabNumber:string, finalSubmitButton?:() => JSX.Element}) => {

    const [previewOpen, setPreviewOpen] = useState(false);
    const componentData = useSelector((state: any) => state.manageIncentive?.data);
    const errorMsg = useSelector((state:any)=>state.manageIncentive?.thresholdErrorMsg?.errorMsg);
    
    const tabDefinition: TabDefinitionType = props.tabDefinition


    const validateTabResults = ()=>{
        let flag = true;
        tabDefinition.tabComponents.forEach(component=>{
            flag = flag && componentData[component.stateName].isValid
        })
        return flag;
    }

    const showPreview = () => {
        if(validateTabResults()){
            setPreviewOpen(true);
        }else{
            if(errorMsg){
                openPopup("Alert", errorMsg);
            }
            else{
                openPopup("Alert", "Please fill and save all the required fields Correctly");
            }
            
        }
    }

    const nextTab = () => {
        if(validateTabResults()){
            const nextTab = parseInt(props.tabNumber) + 1;
            changeIncentiveTab(nextTab + "");
        }else{
            if(errorMsg){
                openPopup("Alert", errorMsg);
            }
            else{
                openPopup("Alert", "Please fill and save all the required fields Correctly");
            }
        }
    }

    const NextButton = () => {
        if(props.finalSubmitButton){
            return props.finalSubmitButton();
        }
        return (
            <div className='incentive-next-button-wrapper'>
                <Button
                    variant="contained"
                    className='incentive-next-button'
                    sx={{
                        marginLeft: 2,
                        height: 35,
                        fontSize: '0.8rem',
                        marginTop: 2,
                        marginRight: 1
                    }}
                    onClick={nextTab}
                >
                    {tabDefinition.preview? "NEXT" : "SAVE AND NEXT"}
            </Button>
            </div>
        );
    }

    const ShowPreviewButton = () => {
        return (
            <div className='incentive-next-button-wrapper'>
                <Button
                    variant="contained"
                    className='incentive-next-button'
                    sx={{
                        marginLeft: 2,
                        height: 35,
                        fontSize: '0.8rem',
                        marginTop: 2,
                        marginRight: 1
                    }}
                    onClick={showPreview}
                >
                    SAVE AND PREVIEW
                </Button>
            </div>);
    }

    const PreviewAndNextButton = () => {
        if (tabDefinition.preview) {
            if (previewOpen) {
                return(
                    <div>
                        <tabDefinition.preview setPreviewOpen={setPreviewOpen}/>
                        <NextButton />
                    </div>
                );
            }else{
                return ShowPreviewButton();
            }
        } else {
            return NextButton();
        }
    }

    return (
        <div>
            <div className={`incentive-component-wrapper ${previewOpen ? 'in-preview' : ""}`}>
                {tabDefinition.tabComponents.map((tabComponent, index) => {
                    const Component = tabComponent.component;
                    return (
                        <div key={index}>
                            <Component stateName={tabComponent.stateName} />
                        </div>
                    );
                })}
            </div>
            <PreviewAndNextButton />
        </div>
    )
}
